import { Box, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CusButton from '../../../../../components/material-ui/CusButton';
import CusSwitch from '../../../../../components/material-ui/CusSwitch';
import CurrencySelect from '../../../../../components/shared/CurrencySelect';
import { API_CASINO } from '../../../../../api/casino';
import CusLink from '../../../../../components/material-ui/CusLink';
import ShowContainer from '../../../../../components/material-ui/ShowContainer';
import useToast from '../../../../../hooks/useToast';

export default function PaymentOtherContent({ casino }) {
  const { t } = useTranslation();
  const { successToast } = useToast();
  const casinoId = casino?.id;
  const [chatOperatorInfo, setChatOperatorInfo] = useState({});
  const [currencies, setCurrencies] = useState([]);
  const [isEmptySupport, setEmptySupport] = useState(false);
  const [supportChat, setSupportChat] = useState(false);

  useEffect(() => {
    if (!casinoId) return;
    API_CASINO.tgCasino
      .get({ casinoId })
      .then((e) => {
        const supportChat = e.data.data.supportChat;
        setEmptySupport(!supportChat);
        setSupportChat(supportChat);
      })
      .catch(console.error);

    API_CASINO.get
      .props({ casinoId, propsCasino: ['mgrPayment'] })
      .then((e) => {
        const info = e.data.info;
        const currencyList = info.mgrPayment?.currencyList;
        setChatOperatorInfo(info.mgrPayment);
        setCurrencies(currencyList?.split(',')?.filter((el) => el) || []);
      })
      .catch(console.error);
  }, [casinoId]);

  const onSave = () => {
    API_CASINO.update({
      casinoId,
      mgrPayment: { ...chatOperatorInfo, currencyList: currencies.join() }
    })
      .then((e) => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  console.log('currencies', currencies);

  return (
    <Stack gap={2}>
      <Typography component={'span'}>
        {t('The "Top up via operator" button leads to a chat with an operator on Telegram')} :{' '}
        <ShowContainer
          condition={supportChat}
          plug={
            <ShowContainer condition={isEmptySupport}>
              <Typography component={'span'}>
                {/* {t('TG account not set')} -{' '} */}
                <CusLink text={'set tg account'} to={`/casino/lang-links/${casinoId}`} />
              </Typography>
            </ShowContainer>
          }>
          <CusLink
            linkComponent="a"
            href={`https://t.me/${supportChat}`}
            target="_blank"
            text={`@${supportChat}`}
          />
        </ShowContainer>
      </Typography>

      <Stack gap={1}>
        <Stack>
          <Box width={'fit-content'}>
            <CusSwitch
              label={'display a button on the website'}
              checked={chatOperatorInfo.siteEnabled}
              reverse
              onChange={() =>
                setChatOperatorInfo((prev) => ({
                  ...prev,
                  siteEnabled: !chatOperatorInfo.siteEnabled
                }))
              }
            />
          </Box>

          <Box width={'fit-content'}>
            <CusSwitch
              label={'display button in TG bot'}
              checked={chatOperatorInfo.botEnabled}
              reverse
              onChange={() =>
                setChatOperatorInfo((prev) => ({
                  ...prev,
                  botEnabled: !chatOperatorInfo.botEnabled
                }))
              }
            />
          </Box>
        </Stack>

        <Stack gap={1} direction={'row'}>
          {/* <Typography width={175}>{t('For selected currencies')}</Typography> */}

          <CurrencySelect
            isRow
            label="For selected currencies"
            value={currencies}
            setValue={setCurrencies}
            multi
          />
        </Stack>
      </Stack>
      <CusButton text="Save" variant="contained" sx={{ px: 5 }} onClick={onSave} />
    </Stack>
  );
}
